
import HeroSection from './components/HeroSection';
import EmpathySection from './components/EmpathySection';
import SolutionSection from './components/SolutionSection';
import ProofSection from './components/ProofSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <EmpathySection />
      <SolutionSection />
      <ProofSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
